/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ text: NonNullable<unknown> }} Actionplacecardrunning3Inputs */

const en_actionplacecardrunning3 = /** @type {(inputs: Actionplacecardrunning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Running: ${i?.text}`)
};

const de_actionplacecardrunning3 = /** @type {(inputs: Actionplacecardrunning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Läuft: ${i?.text}`)
};

/**
* | output |
* | --- |
* | "Running: {text}" |
*
* @param {Actionplacecardrunning3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionplacecardrunning3 = /** @type {((inputs: Actionplacecardrunning3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionplacecardrunning3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionplacecardrunning3(inputs)
	return de_actionplacecardrunning3(inputs)
});
export { actionplacecardrunning3 as "actionPlaceCardRunning" }